// config.ts

interface Config {
    baseUrl: string;
}
export const deploymentType = process.env.NEXT_PUBLIC_DEPLOYMENT_TYPE;
const isLocal = deploymentType === "local";
export const BASE_URL = (isLocal ? process.env.NEXT_PUBLIC_LOCAL_STRAPI_URL : process.env.NEXT_PUBLIC_STRAPI_URL) || "";

const config: Config = {
    baseUrl: BASE_URL,
};

export default config;
